// Home.jsx — Tabs + nhận counts từ ServiceGrid (FE xử lý hết)
import { useState } from "react";
import Banner from "../components/Banner";
import SearchPanel from "../components/SearchPanel";
import ServiceGrid from "../components/ServiceGrid";
import { Baby, Building2, ShoppingBasket, Bell, BadgePercent, UserPlus } from "lucide-react";
import { Link } from "react-router-dom";


const QUICK_ACTIONS = [
  { label: "Bé Học Trống Lục Lạc", Icon: Baby, to: "/be-hoc-trong-luc-lac" },
  { label: "Danh Sách Trúng Thưởng", Icon: Building2, to: "/danh-sach-trung-thuong" },
  { label: "Sản phẩm tạp hoá", Icon: ShoppingBasket, to: "/san-pham-tap-hoa" },
  { label: "Thông báo", Icon: Bell, to: "/thong-bao" },
  { label: "Khuyến mãi", Icon: BadgePercent, to: "/khuyen-mai" },
  { label: "Đăng ký và Hướng Dẫn", Icon: UserPlus, to: "/dang-ky-huong-dan" },
];

function QuickActionCard({ label, Icon, to }) {
  const Inner = (
    <>
      <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-rose-100/70 flex items-center justify-center shadow-sm ring-1 ring-rose-100 group-hover:bg-rose-100">
        <Icon className="w-6 h-6 md:w-7 md:h-7 text-rose-700" />
      </div>
      <span className="mt-2 text-[13px] md:text-sm text-slate-800 leading-snug select-none">
        {label}
      </span>
    </>
  );

  if (to) {
    return (
      <Link
        to={to}
        className="group flex flex-col items-center text-center cursor-pointer rounded-xl p-2 active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-rose-200"
      >
        {Inner}
      </Link>
    );
  }

  return (
    <div className="flex flex-col items-center text-center p-2">
      {Inner}
    </div>
  );
}

export default function Home() {
  const [level, setLevel] = useState("xa"); // 'xa' | 'huyen' | 'tinh'
  const [counts, setCounts] = useState({ xa: null, huyen: null, tinh: null });

  const switchTo = (lv) => setLevel(lv);

  return (
    <>
      {/* Banner */}
      <section className="relative">
        <Banner />
      </section>

      {/* 6 mục nhanh */}
      <section className="max-w-6xl mx-auto px-3 mt-3 md:mt-6">
        <div className="rounded-2xl bg-white shadow-sm ring-1 ring-slate-100">
          <div className="grid grid-cols-3 md:grid-cols-6 gap-y-4 md:gap-y-0 gap-x-2 md:gap-x-6 p-4 md:p-6">
            {QUICK_ACTIONS.map(({ label, Icon, to }) => (
              <QuickActionCard key={label} label={label} Icon={Icon} to={to} />
            ))}
          </div>
        </div>
      </section>

      {/* Search */}
      <section className="max-w-6xl mx-auto px-3 mt-3 md:mt-6">
        <div className="rounded-2xl bg-white shadow-sm ring-1 ring-slate-100 p-3 md:p-4">
          <SearchPanel />
        </div>
      </section>

      {/* Tabs + chip đếm từ ServiceGrid */}
      <section className="max-w-6xl mx-auto px-3 mt-4 md:mt-6">
        <div className="flex gap-2 md:gap-3 overflow-x-auto no-scrollbar">
          <button
            onClick={() => switchTo("xa")}
            className={`px-3 py-2 text-sm md:text-base rounded-xl border ${level === "xa" ? "border-rose-200 bg-rose-50 text-rose-700 font-semibold" : "border-slate-200 text-slate-600"
              }`}
          >
            {`Xã (${counts.xa ?? "…"})`}
          </button>
          <button
            onClick={() => switchTo("huyen")}
            className={`px-3 py-2 text-sm md:text-base rounded-xl border ${level === "huyen" ? "border-rose-200 bg-rose-50 text-rose-700 font-semibold" : "border-slate-200 text-slate-600"
              }`}
          >
            {`Huyện (${counts.huyen ?? "…"})`}
          </button>
          <button
            onClick={() => switchTo("tinh")}
            className={`px-3 py-2 text-sm md:text-base rounded-xl border ${level === "tinh" ? "border-rose-200 bg-rose-50 text-rose-700 font-semibold" : "border-slate-200 text-slate-600"
              }`}
          >
            {`Tỉnh (${counts.tinh ?? "…"})`}
          </button>
        </div>
      </section>

      {/* Lưới dịch vụ — ServiceGrid xử lý fetch, counts & filter */}
      <section className="max-w-6xl mx-auto px-3 mt-3 md:mt-4">
        <ServiceGrid level={level} onCounts={setCounts} />
      </section>
    </>
  );
}

